import io from 'socket.io-client';
import config from 'config';

const api = new URL(config.api.socketBaseURL);

let socket = io.connect(`${api.origin}/content-instance`, {
    transports: ['websocket']
});

export default socket;